/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ComponentPropsWithRef } from 'react';

import { cn } from '@/lib/utils';

type TextareaProps = ComponentPropsWithRef<'textarea'>;

function Textarea({ className, ...props }: TextareaProps) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(
                'placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground field-sizing-content min-h-24 w-full min-w-0 rounded-xs border border-input bg-background px-3 py-3.5 text-sm leading-5 text-foreground shadow-xs outline-none transition-[border-color,box-shadow,color] disabled:pointer-events-none disabled:cursor-not-allowed disabled:border-input disabled:bg-background disabled:text-muted-foreground aria-invalid:border-border aria-invalid:shadow-none disabled:aria-invalid:border-input disabled:aria-invalid:shadow-xs focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-focus focus-visible:aria-invalid:border-destructive focus-visible:aria-invalid:ring-destructive-focus',
                className
            )}
            {...props}
        />
    );
}

export { Textarea };
